import type { ToolCallData } from '@shared/services/conversationApiService/types';

export interface ToolCallMetadata {
  descriptionKey: string;
}

const EXTERNAL_TOOL_METADATA: ToolCallMetadata = {
  descriptionKey: 'campaignPage.toolCall.metadata.externalTool',
};

const INTERNAL_TOOL_METADATA: ToolCallMetadata = {
  descriptionKey: 'campaignPage.toolCall.metadata.internalTool',
};

const FOLLOW_UP_MESSAGE_METADATA: ToolCallMetadata = {
  descriptionKey: 'campaignPage.toolCall.metadata.sendFollowUpMessage',
};

const TOOL_CALL_METADATA: Record<string, ToolCallMetadata> = {
  end_call: { descriptionKey: 'campaignPage.toolCall.metadata.endCall' },
  donot_call: { descriptionKey: 'campaignPage.toolCall.metadata.doNotCall' },
  call_handoff_signal: { descriptionKey: 'campaignPage.toolCall.metadata.callHandoff' },
  send_follow_up_message: FOLLOW_UP_MESSAGE_METADATA,
  request_callback: { descriptionKey: 'campaignPage.toolCall.metadata.requestCallback' },
  transfer_call: { descriptionKey: 'campaignPage.toolCall.metadata.transferCall' },
  send_whatsapp_message: FOLLOW_UP_MESSAGE_METADATA,
  record_inputs: { descriptionKey: 'campaignPage.toolCall.metadata.recordDtmfInputs' },
  confirm_inputs: { descriptionKey: 'campaignPage.toolCall.metadata.confirmDtmfInputs' },
  data_collected: { descriptionKey: 'campaignPage.toolCall.metadata.dataCollected' },
};

const TASK_GROUP_METADATA: ToolCallMetadata = {
  descriptionKey: 'campaignPage.toolCall.metadata.runTaskGroup',
};

const TASK_GROUP_TOOL_PREFIX = 'run_';

export const resolveToolCallMetadata = (
  name: string,
  source: ToolCallData['source'],
): ToolCallMetadata => {
  if (source !== 'local') return EXTERNAL_TOOL_METADATA;

  const metadata = TOOL_CALL_METADATA[name];
  if (metadata) return metadata;
  if (name.startsWith(TASK_GROUP_TOOL_PREFIX)) return TASK_GROUP_METADATA;

  return INTERNAL_TOOL_METADATA;
};
